export default __webpack_public_path__ + "static/media/quantisal_step4.5b6a6940.png";